import React from 'react';

export const AnnouncementBar = () => {
  return (
    <div
      className="fixed top-0 left-0 right-0 bg-wild-leather text-white py-2 overflow-hidden z-[60]"
      data-testid="announcement-bar"
    >
      <div className="flex whitespace-nowrap" style={{ animation: 'marquee 25s linear infinite' }}>
        <div className="flex shrink-0">
          {[...Array(6)].map((_, i) => (
            <span key={i} className="mx-8 font-semibold tracking-wide text-sm">
              ★ NEW DROPS EVERY MONTH
            </span>
          ))}
        </div>
        <div className="flex shrink-0">
          {[...Array(6)].map((_, i) => (
            <span key={`dup-${i}`} className="mx-8 font-semibold tracking-wide text-sm">
              ★ NEW DROPS EVERY MONTH
            </span>
          ))}
        </div>
      </div>
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
};
